import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { message, PageHeader, Spin, Tag } from "antd";
import { AuthCheck, AUTH_ACTIONS } from "authorization";
import StateTag from "Components/state-tag";
import {
  createComponentStore,
  useStoreActions,
  useStoreState,
} from "easy-peasy";
import FourOThree from "Pages/private/403";
import FourOFour from "Pages/private/404";
import React, { useEffect, useState } from "react";
import { useHistory, useParams, useRouteMatch } from "react-router-dom";
import { UnitStoreModel, ACTION_TYPES } from "store/models/master-data/unit";
import { fixDates, GenerateBackPath, isScreenMobile } from "Utils";
import UnitForm from "../components/form";
import DeleteButton from "./components/delete";
import EditButton from "./components/edit";

const useUnitStore = createComponentStore(UnitStoreModel);

export default function UnitDetailsPage({ archived = false, ...props }) {
  const [unit, setUnit] = useState({
    address: "",
    code: null,
    description: "",
    district: "",
    measures: [],
    neighborhood: "",
    province: "",
    version: 0,
  });

  const { abilities } = useStoreState((store) => store.auth);
  const IsAuthorized = AuthCheck(
    abilities,
    archived ? AUTH_ACTIONS.READ_ARCHIVE : AUTH_ACTIONS.READ,
    "Birimler"
  );
  const [store, actions] = useUnitStore();

  const { updateBreadcrumb } = useStoreActions((store) => store.app);

  let { id } = useParams();
  let history = useHistory();
  let match = useRouteMatch();

  const rootPath = GenerateBackPath(match.path, 4);

  useEffect(() => {
    if (!IsAuthorized) return;
    if (archived) actions.fetchDeletedRecord({ id: id });
    else actions.fetchSingle({ id: id });
  }, [id, archived]);

  useEffect(() => {
    if (store.record) {
      updateBreadcrumb({
        object: {
          name: store.record.description,
          path: match.path,
        },
        index: 2,
      });

      setUnit(fixDates(store.record));
    }
  }, [store.record]);

  useEffect(() => {
    if (store.process === ACTION_TYPES.RESTORED_DATA) {
      history.push(`${rootPath}/${id}/detay`);
      message.success("Birim arşivden geri alındı.");
    }

    if (store.process === ACTION_TYPES.REMOVED_DATA) {
      history.push(`${rootPath}/${id}/arsiv`);
      message.success("Birim silindi.");
    }
  }, [store.process]);

  const IsLoading = (process) => {
    return [ACTION_TYPES.FETCHING_DATA].includes(process);
  };

  return store.process === ACTION_TYPES.FINISHED && !store.record ? (
    <FourOFour />
  ) : (
    <>
      <PageHeader
        className={
          isScreenMobile() ? "mobile-customized customized" : "customized"
        }
        backIcon={<FontAwesomeIcon icon={["fas", "chevron-left"]} />}
        onBack={() => {
          history.push(rootPath);
        }}
        title={
          <>
            {`Birim - ${
              store.process === ACTION_TYPES.FETCHING_DATA
                ? "Yükleniyor"
                : IsAuthorized
                ? store.record?.description
                : "Erişim Engllendi"
            }`}
            <StateTag
              state={store.record?.state}
              style={{ marginLeft: 4, display: "inline-block" }}
            />
          </>
        }
        extra={[
          <EditButton key={1} record={store.record} />,
          <DeleteButton
            key={4}
            record={store.record}
            actions={actions}
            loading={
              store.process === ACTION_TYPES.REMOVING_DATA ||
              store.process === ACTION_TYPES.RESTORING_DATA
            }
          />,
        ]}
      />
      {IsAuthorized ? (
        <Spin spinning={IsLoading(store.process)}>
          <div style={{ margin: "0 24px" }}>
            <UnitForm unit={unit} />
          </div>
        </Spin>
      ) : (
        <FourOThree />
      )}
    </>
  );
}
